import { Col } from 'antd';
import React from 'react';
import { v3FieldSortOptions } from './FieldSortOptions';
import { ApiCodeToggle, SearchFilter, SearchFilterContainer, SortByFilter, TagFilter } from '../filters';
import { Else, If, Then } from 'react-if';
export const SalesforceFieldSearch = ({ onChange, queryParams, showInternalNameToggle }) => React.createElement(SearchFilterContainer, null,
    React.createElement(Col, { span: 12 },
        React.createElement(SearchFilter, { onChange: onChange })),
    React.createElement(If, { condition: showInternalNameToggle },
        React.createElement(Then, null,
            React.createElement(Col, { className: 'align-right', span: 12 },
                React.createElement(ApiCodeToggle, { checked: Boolean(queryParams.useInternal), onChange: onChange }))),
        React.createElement(Else, null,
            React.createElement(Col, { span: 12 }))),
    React.createElement(Col, { span: 12 },
        React.createElement(TagFilter, { onChange: onChange })),
    React.createElement(Col, { className: 'align-right', span: 12 },
        React.createElement(SortByFilter, { defaultSortOption: v3FieldSortOptions[1], onChange: onChange, options: v3FieldSortOptions, queryParams: queryParams })));
